import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { memberMove, memberRepairMoney, userList } from '../../../../api/apis';
export default {
  data: function data() {
    return {
      dialogVisible: false,
      grade: '',
      form: {
        number: '',
        real_name: '',
        before_direct: '',
        after_direct: '',
        before_direct_grade: '',
        after_direct_grade: ''
      },
      rules: {
        number: [{
          require: true,
          message: '请输入会员编号',
          trigger: 'blur'
        }],
        before_direct: [{
          require: true,
          message: '请输入原进货网',
          trigger: 'blur'
        }],
        after_direct: [{
          require: true,
          message: '请输入新进货网',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {},
  methods: {
    getGradeName: function getGradeName(tag) {
      var grade = '';

      if (tag === 0) {
        grade = '消费者';
      } else if (tag === 1) {
        grade = '一品店长';
      } else if (tag === 2) {
        grade = '一品达人';
      } else if (tag === 3) {
        grade = '一品高达';
      } else if (tag === 4) {
        grade = '大批发商';
      }

      return grade;
    },
    onDirectChange: function onDirectChange(number) {
      var _this = this;

      if (number.length === 9) {
        userList({
          page: 1,
          limit: 1,
          where: {
            number: number
          }
        }).then(function _callee(res) {
          return regeneratorRuntime.async(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (res.rows.length > 0) {
                    _this.form.after_direct_grade = _this.getGradeName(res.rows[0].grade);
                  }

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          });
        });
      }
    },
    onNumberChange: function onNumberChange(number) {
      var _this2 = this;

      if (number.length === 9) {
        userList({
          page: 1,
          limit: 1,
          where: {
            number: number
          }
        }).then(function _callee3(res) {
          var user;
          return regeneratorRuntime.async(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (res.rows.length > 0) {
                    user = res.rows[0];
                    _this2.form.before_direct = user.pdirect;
                    _this2.form.real_name = user.real_name;
                    _this2.grade = _this2.getGradeName(_this2.form.before_direct);
                    userList({
                      page: 1,
                      limit: 1,
                      where: {
                        number: user.pdirect
                      }
                    }).then(function _callee2(res) {
                      return regeneratorRuntime.async(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              _this2.form.before_direct_grade = _this2.getGradeName(res.rows[0].grade);

                            case 1:
                            case "end":
                              return _context2.stop();
                          }
                        }
                      });
                    });
                  }

                case 1:
                case "end":
                  return _context3.stop();
              }
            }
          });
        });
      }
    },
    show: function show(finish) {
      this.dialogVisible = true;
      this.finish = finish;
    },
    clickSubmit: function clickSubmit() {
      var _this3 = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this3.dialogVisible = false;

          _this3.finish(_this3.form);
        }
      });
    }
  }
};